import PropTypes from 'prop-types';

// import { Link } from 'react-router-dom';

// material-ui
// import { ButtonBase } from '@mui/material';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// project import
// import LogoMain from '../../assets/images/icons/logo.svg';
// import LogoIcon from '../../assets/images/icons/logo-icon-io.svg';
// import { APP_DEFAULT_PATH } from 'config';
import  hilconaMob from '../../assets/images/mob-image/hilcona_mob_size.png';
import  repowerMob from '../../assets/images/mob-image/repower-mob_size.ico';
import  iomarketMob from '../../assets/images/mob-image/favi.svg';
import usePrivateKey from 'hooks/usePrivateKey';

// ==============================|| MAIN LOGO ||============================== /


const LogoSection = ({ isIcon, sx, 
  // to 
}) =>{
  const theme = useTheme();
  const { isIOMDomain } = usePrivateKey();
   const profileData = JSON.parse(sessionStorage.getItem('profiledata') || '{}')?.instance;

   const profileImages = {
    'hilcona': hilconaMob,
    'repower': repowerMob,
    'io-market': iomarketMob
  };
  
  const MobImg = profileImages[profileData] || iomarketMob;

  const logoSrc = isIOMDomain ? (theme.palette.mode === 'dark' ? JSON.parse(localStorage.getItem('whiteLogoImage')) : JSON.parse(localStorage.getItem('logoImage'))
  ):(theme.palette.mode === 'dark' ? `${process.env.REACT_APP_IMAGE_URL}${localStorage.getItem('whiteLogoImage').replace(/"/g, '')}`
    :`${process.env.REACT_APP_IMAGE_URL}${localStorage.getItem('logoImage').replace(/"/g, '')}`);
      console.log("process.env.REACT_APP_IMAGE_URL",logoSrc);


    
return (
  <Box

  /* <ButtonBase disableRipple  */
  // component={Link} to={!to ? "/" : to} 
  sx={isIcon?{sx}:{padding:'15px 10px 0px 40px'}}>
    {isIcon ? <img height={28} src={MobImg} alt='Logo'  /> : 
    //<img src={'https://portal.netgate.io-procurement.com/ngtFiles/netgate05/ngtSysImages/instance/logo-hilcona.png'} alt='Logo' height={70} width={100}/>}
    <img src={logoSrc} alt="Logo" height="80%" width='80%' />}
  {/* </ButtonBase> */}
    </Box>
);
};
LogoSection.propTypes = {
  isIcon: PropTypes.bool,
  sx: PropTypes.object,
  to: PropTypes.string
};

export default LogoSection;
